import { render, staticRenderFns } from "./ComboItemModal.vue?vue&type=template&id=9c534af8&scoped=true"
import script from "./ComboItemModal.vue?vue&type=script&lang=ts"
export * from "./ComboItemModal.vue?vue&type=script&lang=ts"
import style0 from "./ComboItemModal.vue?vue&type=style&index=0&id=9c534af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c534af8",
  null
  
)

export default component.exports